import { render, staticRenderFns } from "./riskspace.vue?vue&type=template&id=8fb9cbb8&scoped=true"
import script from "./riskspace.vue?vue&type=script&lang=js"
export * from "./riskspace.vue?vue&type=script&lang=js"
import style0 from "./riskspace.vue?vue&type=style&index=0&id=8fb9cbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb9cbb8",
  null
  
)

export default component.exports